<div cdkDrag cdkDragRootElement=".ant-modal-content">
  <div *nzModalTitle class="inline" cdkDragHandle>
    Attachments ({{ nzData.files.length }})
    <div class="actions">
      @if (displayUploadFilesButton) {
        <button nz-button nzType="primary" (click)="uploadFiles()">
          <nz-icon nzType="upload" nzTheme="outline" />
          Upload
        </button>
      }

      <nz-icon
        nzType="shrink"
        nzTheme="outline"
        class="button"
        (click)="modal.toggle()"
        *ngIf="!modal.minimized"
      />
      <nz-icon
        nzType="arrows-alt"
        nzTheme="outline"
        class="button"
        (click)="modal.toggle()"
        *ngIf="modal.minimized"
      />
      <nz-icon
        nzType="close-circle"
        (click)="close()"
        class="button cancel"
        nzTheme="outline"
      />
    </div>
  </div>

  <div class="-m-4">
    <app-preview-files
      #PreviewFilesComponent
      [params]="nzData"
      (close)="close()"
    ></app-preview-files>
  </div>
</div>
